import RichText from 'components/shared/richtext';
import Button from 'components/shared/button/button';
import styles from './seoBlock.module.scss';

const SeoBlock = ({ data, locale }) => {
  const { title, underlyingText, button } = data;

  return (
    <div className={styles.blockWrapper}>
      <h2 className={styles.seoTitle}>{title}</h2>
      <RichText className={styles.seoText} text={underlyingText?.json} />
      {button && <Button className={styles.seoButton} locale={locale} button={button} />}
    </div>
  );
};

export default SeoBlock;
